export default __webpack_public_path__ + "static/electronics-card-01-a997d4fc1ba858d7bca7fd2f9cccd901.svg";